var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDasn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.277,
    height: 16.404,
    viewBox: "0 0 15.277 16.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3071",
    "data-name": "Grupo 3071",
    transform: "translate(-222.851 -546.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-calendar",
    "data-name": "Icon feather-calendar",
    transform: "translate(223.351 547.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M6.086,6h11.1a1.611,1.611,0,0,1,1.586,1.635V19.084a1.611,1.611,0,0,1-1.586,1.635H6.086A1.611,1.611,0,0,1,4.5,19.084V7.635A1.611,1.611,0,0,1,6.086,6Z",
    transform: "translate(-4.5 -5.315)",
    fill: "none",
    stroke: "#64c2c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M24,3V4.37",
    transform: "translate(-13.689 -3)",
    fill: "none",
    stroke: "#64c2c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M12,3V4.37",
    transform: "translate(-8.034 -3)",
    fill: "none",
    stroke: "#64c2c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M4.5,15H18.777",
    transform: "translate(-4.5 -10.81)",
    fill: "none",
    stroke: "#64c2c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-balance-scale",
    "data-name": "Icon awesome-balance-scale",
    d: "M3.531,4.635h0c0-.223.018-.12-1.173-2.5a.663.663,0,0,0-1.185,0C-.028,4.535,0,4.419,0,4.635H0c0,.609.791,1.1,1.766,1.1S3.531,5.245,3.531,4.635ZM1.766,2.428l.993,1.987H.772ZM8.828,4.635c0-.223.018-.12-1.173-2.5a.663.663,0,0,0-1.185,0c-1.2,2.4-1.173,2.288-1.173,2.5h0c0,.609.791,1.1,1.766,1.1s1.766-.494,1.766-1.1ZM6.069,4.414l.993-1.987.993,1.987ZM7.283,6.18H4.856V2.114a1.1,1.1,0,0,0,.64-.79H7.283A.221.221,0,0,0,7.5,1.1V.662A.221.221,0,0,0,7.283.441H5.292a1.094,1.094,0,0,0-1.756,0H1.545a.221.221,0,0,0-.221.221V1.1a.221.221,0,0,0,.221.221H3.333a1.1,1.1,0,0,0,.64.79V6.18H1.545a.221.221,0,0,0-.221.221v.441a.221.221,0,0,0,.221.221H7.283A.221.221,0,0,0,7.5,6.842V6.4A.221.221,0,0,0,7.283,6.18Z",
    transform: "translate(226.262 553.122)",
    fill: "#64c2c8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDasn);
export default __webpack_public_path__ + "static/media/DASN.ffc0316b41a634aeed3e614f43fdf237.svg";
export { ForwardRef as ReactComponent };